/* CamWood APPAREL editor -- cwa-v1 + MULTI-SIZE (holiday copy, 2026-10-22).
 * Derived from the live assets/cw-apparel.js by mkengine.py: identical except
 * the opt-in spec.multi feature (one build, several sizes, one Add to cart).
 * Without spec.multi every path below behaves exactly like cw-apparel.js.
 * ----------------------------------------------------------------------------
 * Original header:  Shirts, hoodies, hats.
 * ============================================================================
 * A SEPARATE ENGINE. It shares the bat editor's design language and nothing
 * else: this file does not import, extend, patch or read cw-editor.js, and it
 * declares no global except window.CWApparel + the CW_APPAREL_CONFIG it reads.
 *
 * WHAT IT DOES
 *   1. reads CW_APPAREL_CONFIG (emitted by the section: spec url, variant id,
 *      variant SKU, formatted price, product url)
 *   2. fetches the spec: panels (+their CPB visibility logic), grouped UI
 *      steps, and a COMBINATION -> pre-composed image lookup
 *   3. drives a gated tab flow and posts ONE /cart/add.js
 *
 * THE THREE DERIVED FACTS IT IMPLEMENTS (see REPORT-A1 for the evidence)
 *   * property KEY   = panel.title + " - "  (so a conditional twin panel
 *     changes the key: "Select Hoodie Elite Logo Color - Gray - ")
 *   * property ORDER = "SKU" first, then panels in CPB config order, visible
 *     ones only
 *   * property SKU   = the Shopify VARIANT's sku, verbatim, empty string
 *     included -- NOT anything from the CPB config, all of which are empty
 *
 * ASCII-ONLY string literals (house trap: non-ASCII has broken this codebase
 * twice). Escape as \uXXXX.
 * ========================================================================== */
(function () {
  "use strict";

  /* ---- module scope. EVERY name assigned anywhere in this file is declared
     HERE. The bat editor shipped a boot-time ReferenceError because a name
     assigned at module scope was declared inside a function; boot_apparel.mjs
     runs this whole file in a stubbed DOM to keep that class dead. ---------- */
  var CFG = {}, SPEC = null, EDITOR_TAG = "cwa-v1";
  var QTY = {};            /* MULTI-SIZE: size optionId -> count (only when spec.multi) */
  var ROOT = null, STAGE = null, FRAME = null, IMGA = null, IMGB = null, SHOWN = null;
  var TABS = null, OPTS = null, OPTSWRAP = null, COMMIT = null, PRICE = null;
  var NEXT = null, BACK = null, VIEWCART = null, STEPOF = null, BADGE = null;
  var ERRBOX = null, ERRTXT = null, ERRCLOSE = null, LIVE = null, MORE = null, MOREWRAP = null;
  var SEL = {};            /* panelId -> optionId  (the authoritative state) */
  var STEP = 0, NSTEP = 0, ADDED = false, BUSY = false, GATEHINT = "";
  var STAGEBOX = [0, 0, 1, 1], LOGOBOX = [0, 0, 1, 1];
  var SEQ = 0, LASTKEY = "", RESIZE_T = 0;
  var FLOW = [];           /* indices into steps() that the customer walks */

  /* ---------------------------------------------------------------- utils */
  function $(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;")
      .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function say(msg) { if (LIVE) LIVE.textContent = String(msg || ""); }

  /* ------------------------------------------------------- CPB visibility
     Derived from the config, not guessed: panel.logic = {rules:[], action}.
     A rule fires when the named panel's CURRENT selection is the named option.
     action "show"  => hidden unless a rule fires.
     action "hide"  => shown  unless a rule fires.
     No rules       => always visible.
     (Every apparel rule joins with "||", i.e. OR, which is what any() is.) */
  function panelVisible(p) {
    var lg = p.logic || {}, rules = lg.rules || [], i, fired = false;
    if (!rules.length) return true;
    for (i = 0; i < rules.length; i++) {
      if (SEL[rules[i].panel] === rules[i].option) { fired = true; break; }
    }
    return (lg.action === "show") ? fired : !fired;
  }
  function panels() { return (SPEC && SPEC.panels) || []; }
  function visiblePanels() {
    var out = [], ps = panels(), i;
    for (i = 0; i < ps.length; i++) if (panelVisible(ps[i])) out.push(ps[i]);
    return out;
  }
  function panelById(id) {
    var ps = panels(), i;
    for (i = 0; i < ps.length; i++) if (ps[i].id === id) return ps[i];
    return null;
  }
  function labelOf(p) {
    var i, os = p.options || [];
    for (i = 0; i < os.length; i++) if (os[i].id === SEL[p.id]) return os[i].label;
    return null;
  }
  /* ---- MULTI-SIZE (opt-in via spec.multi). One build, several sizes: the
     size panel holds a COUNT per option instead of one choice, and Add to
     cart posts one line per size. Nothing below runs without spec.multi. */
  function isMulti(p) { return !!(p && SPEC && SPEC.multi && SPEC.multi.panel === p.id); }
  function qmax() { return (SPEC && SPEC.multi && SPEC.multi.max) || 20; }
  function qLines(p) {
    var out = [], i, o;
    for (i = 0; i < p.options.length; i++) {
      o = p.options[i];
      if (QTY[o.id] > 0) out.push({ id: o.id, label: o.label, n: QTY[o.id] });
    }
    return out;
  }
  function qTotal() {
    var k, n = 0;
    for (k in QTY) if (Object.prototype.hasOwnProperty.call(QTY, k)) n += QTY[k] > 0 ? QTY[k] : 0;
    return n;
  }
  function multiPanel() { return SPEC && SPEC.multi ? panelById(SPEC.multi.panel) : null; }
  /* long = Review / step label ("1 \u00d7 Youth Small, 2 \u00d7 Adult XL");
     short = the stage badge (a single size reads as itself, more as "3 shirts") */
  function qSummary(p, short) {
    var ls = qLines(p), i, parts = [];
    if (!ls.length) return null;
    if (short) return (ls.length === 1 && ls[0].n === 1) ? ls[0].label : qTotal() + " " + qNoun(qTotal());
    for (i = 0; i < ls.length; i++) parts.push(ls[i].n + " \u00d7 " + ls[i].label);
    return parts.join(", ");
  }
  function qNoun(n) {
    var w = (SPEC && SPEC.multi && SPEC.multi.noun) || "item";
    return n === 1 ? w : w + "s";
  }
  /* keep SEL pointing at a chosen size so any single-value reader still sees one */
  function qSync(p) {
    var ls = qLines(p);
    if (ls.length) SEL[p.id] = ls[0].id; else delete SEL[p.id];
  }
  function qSet(p, oid, n) {
    if (n < 0) n = 0;
    if (n > qmax()) n = qmax();
    if (n) QTY[oid] = n; else delete QTY[oid];
    qSync(p);
  }
  function money(cents) {
    var t = String(CFG.priceText || ""), v = (cents / 100).toLocaleString("en-US",
      { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return /[\d][\d.,]*/.test(t) ? t.replace(/[\d][\d.,]*/, v) : ("$" + v);
  }

  /* the single visible panel of a UI step (asserted 1-of-N at build time) */
  function stepPanel(s) {
    var i, p;
    for (i = 0; i < s.panels.length; i++) {
      p = panelById(s.panels[i]);
      if (p && panelVisible(p)) return p;
    }
    return null;
  }
  function stepValue(s) {
    var p = stepPanel(s);
    if (isMulti(p)) return qSummary(p, false);
    return p ? labelOf(p) : null;
  }
  function steps() { return (SPEC && SPEC.steps) || []; }

  /* A step whose every panel offers ONE option is not a choice -- CPB
     pre-selects it too (proven: the lightweight hoodies have a single colour
     and their real orders still carry "Select Shirt Color - " = the only
     value). It is auto-selected at start(), kept OUT of the tab flow, and
     shown read-only on Review so the customer still sees what they are
     buying. Requiring a tap on a one-option panel would be ceremony, not a
     choice; inventing a value where CPB offers several would be a silent
     default. Neither happens here. */
  function stepFixed(s) {
    var i, p, n = 0;
    for (i = 0; i < s.panels.length; i++) {
      p = panelById(s.panels[i]);
      if (p && p.options.length > 1) n++;
    }
    return n === 0;
  }
  function buildFlow() {
    var ss = steps(), i;
    FLOW = [];
    for (i = 0; i < ss.length; i++) if (!stepFixed(ss[i])) FLOW.push(i);
  }
  function flowStep(i) { return steps()[FLOW[i]]; }
  function isReview(i) { return i === FLOW.length; }

  /* ------------------------------------------------------------ selection */
  /* Choosing the LEAD option can swap which twin panel is visible (the
     heavyweight hoodie's colour drives both the logo panel AND the size
     panel). Carry every group's choice across BY LABEL -- the twins share
     their label sets by design -- and clear only when the new panel genuinely
     does not offer it (Black hoodie has no "Large"), saying so out loud. */
  function reconcile() {
    var ss = steps(), i, j, s, p, want, hit, dropped = [];
    for (i = 0; i < ss.length; i++) {
      s = ss[i];
      p = stepPanel(s);
      if (!p) continue;
      if (SEL[p.id] !== undefined) continue;          /* already resolved */
      want = null;
      for (j = 0; j < s.panels.length; j++) {
        var q = panelById(s.panels[j]);
        if (q && q.id !== p.id && SEL[q.id] !== undefined) { want = labelOf(q); break; }
      }
      if (want == null) continue;
      hit = null;
      for (j = 0; j < p.options.length; j++) if (p.options[j].label === want) hit = p.options[j].id;
      if (hit) SEL[p.id] = hit; else dropped.push([s.label, want]);
    }
    /* selections on panels that are no longer visible are kept in SEL but are
       never read (visiblePanels() is the only reader), so returning to the
       old colour restores the old choice for free. */
    return dropped;
  }

  function pick(panelId, optionId) {
    var p = panelById(panelId), i, ok = false;
    if (!p) return null;
    for (i = 0; i < p.options.length; i++) if (p.options[i].id === optionId) ok = true;
    if (!ok) return null;
    if (isMulti(p)) {
      qSet(p, optionId, QTY[optionId] > 0 ? 0 : 1);
      render();
      return labelOf(p);
    }
    SEL[p.id] = optionId;
    var dropped = reconcile();
    if (dropped.length) {
      say(dropped.map(function (d) {
        return d[1] + " is not offered here, so " + d[0] + " needs a new choice.";
      }).join(" "));
    }
    render();
    return labelOf(p);
  }

  /* --------------------------------------------------------- combo lookup */
  function comboKey() {
    var vs = visiblePanels(), parts = [], i, l;
    for (i = 0; i < vs.length; i++) {
      if (!vs[i].image) continue;
      l = labelOf(vs[i]);
      if (l == null) return null;
      parts.push(vs[i].title + "=" + l);
    }
    return parts.length ? parts.join("|") : null;
  }
  /* the combo key we would have if `panel` were set to `label` -- used to
     paint the option cards/tiles with the customer's OWN current build */
  function comboKeyWith(panelId, label) {
    var save = SEL[panelId], p = panelById(panelId), i, k;
    if (!p) return null;
    for (i = 0; i < p.options.length; i++) {
      if (p.options[i].label === label) { SEL[panelId] = p.options[i].id; break; }
    }
    var drop = [], j, ss = steps(), s, q, want, hit;
    /* mirror reconcile() WITHOUT mutating anything the customer can see: the
       twins share label sets, so a hypothetical key resolves the same way */
    var tmp = {};
    for (j = 0; j < ss.length; j++) {
      s = ss[j]; q = stepPanel(s);
      if (!q || SEL[q.id] !== undefined) continue;
      want = null;
      for (i = 0; i < s.panels.length; i++) {
        var r = panelById(s.panels[i]);
        if (r && r.id !== q.id && SEL[r.id] !== undefined) { want = labelOf(r); break; }
      }
      if (want == null) continue;
      hit = null;
      for (i = 0; i < q.options.length; i++) if (q.options[i].label === want) hit = q.options[i].id;
      if (hit) { SEL[q.id] = hit; tmp[q.id] = 1; }
    }
    k = comboKeyFallback();
    for (i in tmp) if (Object.prototype.hasOwnProperty.call(tmp, i)) delete SEL[i];
    if (save === undefined) delete SEL[panelId]; else SEL[panelId] = save;
    return k;
  }
  /* a key for PREVIEW purposes: unchosen image panels fall back to their first
     option, so a card can be painted before every step is answered */
  function comboKeyFallback() {
    var vs = visiblePanels(), parts = [], i, l;
    for (i = 0; i < vs.length; i++) {
      if (!vs[i].image) continue;
      l = labelOf(vs[i]);
      if (l == null) l = vs[i].options[0].label;
      parts.push(vs[i].title + "=" + l);
    }
    return parts.length ? parts.join("|") : null;
  }
  function stageUrl(k) { return k && SPEC.combos ? SPEC.combos[k] : null; }
  /* keyed on (overlay panel title, option label) -- NOT on the combination:
     the card is garment-independent by ruling. */
  function markUrl(p, o) {
    var m = SPEC && SPEC.marks;
    return m ? (m[p.title + "=" + o.label] || null) : null;
  }

  /* -------------------------------------------------------------- framing */
  function applyFrame(host, img, box) {
    var L = box[0], T = box[1], w = box[2] - box[0], h = box[3] - box[1];
    if (!(w > 0) || !(h > 0)) { w = 1; h = 1; L = 0; T = 0; }
    host.style.setProperty("--cwa-ar", (w / h).toFixed(5));
    img.style.width = (100 / w) + "%";
    img.style.height = (100 / h) + "%";
    img.style.left = (-100 * L / w) + "%";
    img.style.top = (-100 * T / h) + "%";
  }

  /* Poster-style swap: paint into the HIDDEN element, wait for it to decode,
     then flip. The previous garment stays on screen the whole time, so a slow
     network shows the old picture rather than a white hole. */
  function showStage(url) {
    if (!url || !FRAME) return;
    if (url === LASTKEY) return;
    LASTKEY = url;
    var mine = ++SEQ;
    var target = (SHOWN === IMGA) ? IMGB : IMGA;
    var done = function () {
      if (mine !== SEQ) return;
      target.classList.add("cwa-on");
      if (SHOWN && SHOWN !== target) SHOWN.classList.remove("cwa-on");
      SHOWN = target;
      STAGE.setAttribute("data-busy", "0");
    };
    STAGE.setAttribute("data-busy", "1");
    target.onload = done;
    target.onerror = function () {
      if (mine !== SEQ) return;
      STAGE.setAttribute("data-busy", "0");
      showError("A preview image did not load. Your choices are still saved.");
    };
    target.src = url;
    applyFrame(FRAME, target, STAGEBOX);
    if (target.decode) { target.decode().then(done, function () { }); }
    else if (target.complete) done();
  }

  /* ----------------------------------------------------------- completion */
  function stepDone(i) {
    var s = flowStep(i);
    return !!(s && stepValue(s) != null);
  }
  function firstIncomplete() {
    var i;
    for (i = 0; i < FLOW.length; i++) if (!stepDone(i)) return i;
    return -1;
  }
  function missingSteps() {
    var i, out = [];
    for (i = 0; i < FLOW.length; i++) if (!stepDone(i)) out.push(i);
    return out;
  }
  /* a step is reachable when everything before it is answered; Back is always
     allowed, so any step at or before the frontier is open */
  function maxOpen() {
    var fi = firstIncomplete();
    return fi < 0 ? FLOW.length : fi;
  }

  /* ------------------------------------------------------------- rendering */
  function renderTabs() {
    var html = "", i, open = maxOpen(), v, s;
    for (i = 0; i < FLOW.length; i++) {
      s = flowStep(i); v = stepValue(s);
      html += '<button type="button" role="tab" data-step="' + i + '"'
        + ' aria-selected="' + (STEP === i ? "true" : "false") + '"'
        + ' class="' + (v != null ? "cwa-done " : "") + (i > open ? "cwa-locked" : "") + '">'
        + '<span class="cwa-tk">' + (v != null ? "\u2713" : (i + 1)) + "</span>"
        + '<span class="cwa-tl">' + esc(s.label) + "</span></button>";
    }
    html += '<button type="button" role="tab" data-step="' + FLOW.length + '"'
      + ' aria-selected="' + (STEP === FLOW.length ? "true" : "false") + '"'
      + ' class="' + (missingSteps().length ? "cwa-locked" : "") + '">'
      + '<span class="cwa-tk">' + (missingSteps().length ? (FLOW.length + 1) : "\u2713") + "</span>"
      + '<span class="cwa-tl">Review</span></button>';
    TABS.innerHTML = html;
  }

  function cardsHtml(p, s) {
    var i, html = '<div class="cwa-cards">', o, k, u, on;
    for (i = 0; i < p.options.length; i++) {
      o = p.options[i];
      k = comboKeyWith(p.id, o.label);
      u = stageUrl(k);
      on = SEL[p.id] === o.id;
      html += '<button type="button" data-panel="' + esc(p.id) + '" data-opt="' + esc(o.id) + '"'
        + ' aria-pressed="' + (on ? "true" : "false") + '">'
        + '<span class="cwa-cardpic" data-frame="stage">'
        + (u ? '<img alt="" decoding="async" fetchpriority="high" src="' + esc(u) + '">' : "")
        + "</span>"
        + '<span class="cwa-cardlab">' + esc(o.label) + "</span></button>";
    }
    return html + "</div>";
  }
  /* LOGO / PATCH PICKER -- the bat editor's card, reproduced from MEASURED
     values (see cw-apparel.css). Owner ruling 2026-08-23: the card is the
     standard light-grey chip with the logo MARK on it, ALWAYS the same grey
     whatever garment colour is selected -- explicitly NOT a crop of the chosen
     garment, which is what shipped first. No text label on the card, exactly
     like the bat editor; the group label carries the chosen value, and the
     name is on title/aria-label so it is available to a pointer and to a
     screen reader. */
  function tilesHtml(p) {
    var i, html = '<div class="cwa-sw cwa-logos">', o, u, on;
    for (i = 0; i < p.options.length; i++) {
      o = p.options[i];
      u = markUrl(p, o);
      on = SEL[p.id] === o.id;
      html += '<button type="button" data-panel="' + esc(p.id) + '" data-opt="' + esc(o.id) + '"'
        + ' aria-pressed="' + (on ? "true" : "false") + '"'
        + ' title="' + esc(o.label) + '" aria-label="' + esc(o.label) + '">'
        + '<span class="cwa-vis">'
        + (u ? '<img alt="" decoding="async" src="' + esc(u) + '">' : "")
        + "</span></button>";
    }
    return html + "</div>";
  }
  function chipsHtml(p) {
    var i, html = '<div class="cwa-chips">', o, on, multi = isMulti(p);
    for (i = 0; i < p.options.length; i++) {
      o = p.options[i]; on = multi ? QTY[o.id] > 0 : SEL[p.id] === o.id;
      html += '<button type="button" data-panel="' + esc(p.id) + '" data-opt="' + esc(o.id) + '"'
        + ' aria-pressed="' + (on ? "true" : "false") + '">' + esc(o.label) + "</button>";
    }
    return html + "</div>" + (multi ? qListHtml(p) : "");
  }
  function qListHtml(p) {
    var ls = qLines(p), i, l, html, n = qTotal();
    if (!ls.length) {
      return '<p class="cwa-qempty">Shopping for more than one? Tap every size you need, '
        + "then set how many of each.</p>";
    }
    html = '<div class="cwa-qlist" aria-label="Sizes in this order">'
      + '<div class="cwa-qhead"><span>Your ' + esc(qNoun(2)) + "</span>"
      + '<span class="cwa-qsum">' + n + " " + esc(qNoun(n))
      + (CFG.priceCents ? " \u00b7 " + esc(money(CFG.priceCents * n)) : "") + "</span></div>";
    for (i = 0; i < ls.length; i++) {
      l = ls[i];
      html += '<div class="cwa-qrow"><span class="cwa-qlab">' + esc(l.label) + "</span>"
        + '<button type="button" class="cwa-qbtn" data-qpanel="' + esc(p.id) + '" data-qopt="' + esc(l.id) + '"'
        + ' data-qd="-1" aria-label="One fewer ' + esc(l.label) + '">\u2212</button>'
        + '<span class="cwa-qn" aria-live="polite">' + l.n + "</span>"
        + '<button type="button" class="cwa-qbtn" data-qpanel="' + esc(p.id) + '" data-qopt="' + esc(l.id) + '"'
        + ' data-qd="1" aria-label="One more ' + esc(l.label) + '"' + (l.n >= qmax() ? " disabled" : "")
        + ">+</button></div>";
    }
    return html + "</div>";
  }

  function renderReview() {
    var ss = steps(), i, html = "", v;
    if (ADDED) {
      OPTS.innerHTML = '<div class="cwa-done-card"><h3><span class="cwa-tick">\u2713</span>'
        + "Added to your cart</h3><p>" + esc(CFG.title || "Your item")
        + " is in the cart. You can keep shopping or check out.</p>"
        + '<div class="cwa-done-actions">'
        + '<a class="cwa-cta" href="/cart">Go to cart</a>'
        + '<button type="button" class="cwa-cta cwa-ghost" data-act="again">Build another</button>'
        + "</div></div>";
      return;
    }
    html = '<div class="cwa-grp"><span class="cwa-glabel">Your build</span>'
      + '<span class="cwa-ghint">Check it over, then add it to your cart.</span></div>'
      + '<div class="cwa-rev">';
    for (i = 0; i < ss.length; i++) {
      v = stepValue(ss[i]);
      var fx = FLOW.indexOf(i);
      html += '<div class="cwa-revrow' + (v == null ? " cwa-gap" : "") + '">'
        + '<span class="cwa-revk">' + esc(ss[i].label) + "</span>"
        + '<span class="cwa-revv">' + (v == null ? "Still needs a choice" : esc(v)) + "</span>"
        + (fx < 0 ? ""
          : '<button type="button" class="cwa-revbtn" data-goto="' + fx + '">'
            + (v == null ? "Choose" : "Change") + "</button>")
        + "</div>";
    }
    OPTS.innerHTML = html + "</div>";
  }

  function render() {
    if (!SPEC || !ROOT) return;
    var ss = steps(), s, p, html;
    if (STEP > FLOW.length) STEP = FLOW.length;
    if (STEP < 0) STEP = 0;
    renderTabs();

    if (isReview(STEP)) {
      renderReview();
    } else {
      s = flowStep(STEP); p = stepPanel(s);
      var chosen = stepValue(s);
      html = '<div class="cwa-grp"><span class="cwa-glabel">' + esc(s.prompt)
        + '<span>' + (chosen == null ? " \u2014 not chosen" : " \u2014 " + esc(chosen))
        + "</span></span>";
      if (p && p.options.length > 1) {
        html += '<span class="cwa-ghint">' + p.options.length + " to choose from.</span>";
      }
      html += "</div>";
      if (!p) html += '<p class="cwa-ghint">This step is not available for the choices above.</p>';
      else if (s.lead) html += cardsHtml(p, s);
      else if (s.image) html += tilesHtml(p);
      else html += chipsHtml(p);
      OPTS.innerHTML = html;
      applyFrames();
    }

    /* stage: the customer's real build, falling back to first options so the
       garment is never a blank box on first paint */
    var k = comboKey() || comboKeyFallback();
    var u = stageUrl(k);
    if (u) showStage(u);
    renderBadges();

    /* commit bar */
    var miss = missingSteps();
    /* NO STEP COUNTER. Owner ruling, carried over from the bat editors: no
       "2/5"-style position readout in the commit bar -- the tab row already
       says where you are, and the bar's left slot belongs to Back. The element
       is tolerated if an older cached snippet still ships it, but nothing is
       ever written into it. */
    if (STEPOF) STEPOF.textContent = "";
    BACK.hidden = (STEP === 0);
    VIEWCART.hidden = !ADDED;
    if (ADDED) {
      NEXT.textContent = "Build another";
      NEXT.classList.remove("cwa-gated");
      NEXT.disabled = false;
    } else if (isReview(STEP)) {
      NEXT.textContent = miss.length ? "Finish " + flowStep(miss[0]).label : "Add to cart";
      NEXT.classList.toggle("cwa-gated", miss.length > 0);
      NEXT.disabled = !!BUSY;
    } else {
      var done = stepDone(STEP);
      NEXT.textContent = (STEP + 1 < FLOW.length)
        ? "Next: " + flowStep(STEP + 1).label : "Next: Review";
      NEXT.classList.toggle("cwa-gated", !done);
      NEXT.disabled = false;
      GATEHINT = done ? "" : ("Pick a " + flowStep(STEP).label.toLowerCase() + " to continue.");
    }
    if (multiPanel()) {
      var qn = qTotal();
      if (PRICE && CFG.priceCents) PRICE.textContent = money(CFG.priceCents * (qn > 1 ? qn : 1));
      if (!ADDED && isReview(STEP) && !miss.length && qn > 1) NEXT.textContent = "Add " + qn + " to cart";
    }
    if (BUSY) NEXT.textContent = "Adding\u2026";
    measureMore();
  }

  function renderBadges() {
    var ss = steps(), i, v, html = "";
    for (i = 0; i < ss.length; i++) {
      v = isMulti(stepPanel(ss[i])) ? qSummary(stepPanel(ss[i]), true) : stepValue(ss[i]);
      if (v != null) html += "<span>" + esc(v) + "</span>";
    }
    BADGE.innerHTML = html;
  }

  /* Only the GARMENT cards are framed. The logo/patch cards are the bat
     editor's fixed-size chips with `object-fit:contain`, so they need no
     per-product geometry at all -- that is the point of the ruling. */
  function applyFrames() {
    var i, els = OPTS.querySelectorAll('[data-frame="stage"]'), el, img;
    for (i = 0; i < els.length; i++) {
      el = els[i];
      img = el.querySelector("img");
      if (img) applyFrame(el, img, STAGEBOX);
    }
  }

  /* "more below" pill: shown only when the options scroller actually has
     content out of view, hidden the moment it does not. */
  function measureMore() {
    if (!OPTS || !ROOT) return;
    var over = OPTS.scrollHeight - OPTS.clientHeight - OPTS.scrollTop;
    ROOT.setAttribute("data-more", over > 24 ? "1" : "0");
  }

  /* ---------------------------------------------------------------- errors */
  function showError(msg) {
    if (!ERRBOX) return;
    ERRTXT.innerHTML = "<b>Heads up.</b> " + esc(msg);
    ERRBOX.hidden = false;
    say(msg);
  }
  function clearError() { if (ERRBOX) ERRBOX.hidden = true; }

  /* ------------------------------------------------------------- cart path */
  /* THE CONTRACT. Keys and order are derived (see the header); the CPB-internal
     keys (_configId,_productUrl,_cpb_frs_id,_image) are deliberately absent --
     they are the app's own bookkeeping, not the merchant's contract. */
  function propRows() {
    var rows = [["SKU", String(CFG.sku == null ? "" : CFG.sku)]];
    var vs = visiblePanels(), i, l;
    for (i = 0; i < vs.length; i++) {
      l = labelOf(vs[i]);
      if (l == null) continue;
      rows.push([vs[i].key, l]);
    }
    return rows;
  }
  /* MULTI-SIZE: the same build once per chosen size, each with its own count.
     Property keys and order are exactly propRows(); only the size VALUE differs. */
  function multiItems() {
    var p = multiPanel(), ls = p ? qLines(p) : [], out = [], i, j, rows, props;
    for (i = 0; i < ls.length; i++) {
      rows = propRows(); props = {};
      for (j = 0; j < rows.length; j++) props[rows[j][0]] = (rows[j][0] === p.key) ? ls[i].label : rows[j][1];
      if (EDITOR_TAG) props["_editor"] = EDITOR_TAG;
      out.push({ id: CFG.variantId, quantity: ls[i].n, properties: props });
    }
    return out;
  }
  function buildPayload() {
    if (multiPanel() && panelVisible(multiPanel())) return { items: multiItems() };
    var props = {}, rows = propRows(), i;
    for (i = 0; i < rows.length; i++) props[rows[i][0]] = rows[i][1];
    if (EDITOR_TAG) props["_editor"] = EDITOR_TAG;
    return { id: CFG.variantId, quantity: 1, properties: props };
  }

  function addToCart() {
    clearError();
    var miss = missingSteps();
    if (miss.length) { STEP = miss[0]; render(); say(GATEHINT); return; }
    var payload = buildPayload();
    if (!(payload.id || (payload.items && payload.items.length && CFG.variantId))) {
      showError("This product is not configured for checkout yet."); return;
    }
    if (CFG.addToCart === false) { ADDED = true; render(); return; }
    BUSY = true; render();
    fetch(CFG.addUrl || "/cart/add.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.text().then(function (t) { return { ok: r.ok, status: r.status, text: t }; });
    }).then(function (r) {
      BUSY = false;
      if (!r.ok) {
        var m = "";
        try { m = (JSON.parse(r.text) || {}).description || ""; } catch (e) { m = ""; }
        showError(m || ("The cart refused this item (HTTP " + r.status + ")."));
        render(); return;
      }
      ADDED = true; STEP = FLOW.length; render();
      say("Added to your cart.");
      document.dispatchEvent(new CustomEvent("cwa:added", { detail: payload }));
    })["catch"](function () {
      BUSY = false;
      showError("The cart could not be reached. Nothing was added.");
      render();
    });
  }

  /* ---------------------------------------------------------------- events */
  function onClick(e) {
    var t = e.target && e.target.closest ? e.target.closest("button,a") : null;
    if (!t) return;
    var st = t.getAttribute("data-step");
    if (st !== null) {
      var i = parseInt(st, 10);
      if (i <= maxOpen()) { STEP = i; clearError(); render(); OPTS.scrollTop = 0; }
      else say("Finish the earlier steps first.");
      return;
    }
    var g = t.getAttribute("data-goto");
    if (g !== null) { STEP = parseInt(g, 10); clearError(); render(); OPTS.scrollTop = 0; return; }
    if (t.getAttribute("data-act") === "again") { resetBuild(); return; }
    var qp = t.getAttribute("data-qpanel");
    if (qp) {
      var qpan = panelById(qp), qo = t.getAttribute("data-qopt");
      if (qpan && isMulti(qpan)) {
        clearError();
        qSet(qpan, qo, (QTY[qo] || 0) + parseInt(t.getAttribute("data-qd"), 10));
        render();
      }
      return;
    }
    var pid = t.getAttribute("data-panel"), oid = t.getAttribute("data-opt");
    if (pid && oid) { clearError(); pick(pid, oid); return; }
  }
  function resetBuild() {
    SEL = {}; QTY = {}; ADDED = false; STEP = 0; LASTKEY = ""; autoSelectSingles();
    clearError(); render();
  }
  function onNext() {
    if (ADDED) { resetBuild(); return; }
    if (isReview(STEP)) { addToCart(); return; }
    if (!stepDone(STEP)) { say(GATEHINT); showError(GATEHINT); return; }
    STEP += 1; clearError(); render(); OPTS.scrollTop = 0;
  }
  function onBack() { if (STEP > 0) { STEP -= 1; clearError(); render(); OPTS.scrollTop = 0; } }

  /* --------------------------------------------------------------- binding */
  function bind() {
    ROOT = $("cwa-root");
    if (!ROOT) return false;
    STAGE = $("cwa-stage"); FRAME = $("cwa-frame"); IMGA = $("cwa-imgA"); IMGB = $("cwa-imgB");
    TABS = $("cwa-tabs"); OPTS = $("cwa-opts"); OPTSWRAP = $("cwa-optswrap");
    COMMIT = $("cwa-commit"); PRICE = $("cwa-price"); NEXT = $("cwa-next"); BACK = $("cwa-back");
    VIEWCART = $("cwa-viewcart"); STEPOF = $("cwa-stepof"); BADGE = $("cwa-badge");
    ERRBOX = $("cwa-err"); ERRTXT = $("cwa-err-text"); ERRCLOSE = $("cwa-err-close");
    LIVE = $("cwa-live"); MORE = $("cwa-more"); MOREWRAP = $("cwa-morewrap");
    if (!STAGE || !FRAME || !IMGA || !IMGB || !TABS || !OPTS || !NEXT) return false;
    ROOT.addEventListener("click", onClick);
    NEXT.addEventListener("click", onNext);
    BACK.addEventListener("click", onBack);
    if (ERRCLOSE) ERRCLOSE.addEventListener("click", clearError);
    if (MORE) MORE.addEventListener("click", function () {
      OPTS.scrollTop = OPTS.scrollTop + Math.max(120, OPTS.clientHeight * 0.8);
    });
    OPTS.addEventListener("scroll", measureMore);
    window.addEventListener("resize", function () {
      if (RESIZE_T) clearTimeout(RESIZE_T);
      RESIZE_T = setTimeout(measureMore, 120);
    });
    window.addEventListener("orientationchange", function () { setTimeout(measureMore, 220); });
    return true;
  }

  function fatal(msg) {
    if (ROOT) {
      ROOT.setAttribute("data-state", "error");
      var t = $("cwa-fatal-text");
      if (t) t.textContent = msg;
    }
  }

  function start(spec) {
    SPEC = spec;
    STAGEBOX = spec.stageBox || [0, 0, 1, 1];
    /* Some CPB garment layers carry an OPAQUE backdrop rectangle (measured:
       the razorback and the lightweight SS hoodie are white-boxed, the tees
       and hoodies are cut out). Painting the stage that colour removes the
       visible seam between the framed art and the stage; products with cut-out
       art keep the tinted gradient. Derived at build time, never guessed. */
    if (spec.stageBg) STAGE.style.background = spec.stageBg;
    LOGOBOX = spec.logoBox || [0, 0, 1, 1];
    autoSelectSingles();
    buildFlow();
    NSTEP = FLOW.length + 1;
    if (PRICE) PRICE.textContent = CFG.priceText || "";
    ROOT.setAttribute("data-state", "ready");
    render();
  }

  function autoSelectSingles() {
    var ps = panels(), i;
    for (i = 0; i < ps.length; i++) {
      if (ps[i].options && ps[i].options.length === 1) SEL[ps[i].id] = ps[i].options[0].id;
    }
  }

  function boot() {
    CFG = (window.CW_APPAREL_CONFIG || {});
    if (CFG.editorTag !== undefined) EDITOR_TAG = CFG.editorTag;
    if (!bind()) return;
    var retry = $("cwa-retry");
    if (retry) retry.addEventListener("click", function () { load(); });
    load();
  }
  function load() {
    /* CFG.spec: an already-parsed spec object instead of a url. Used by the
       standalone owner mockup so it runs THIS file, byte-identical to the
       deployed one, with no network at all. Production always uses specUrl. */
    if (CFG.spec && typeof CFG.spec === "object") {
      ROOT.setAttribute("data-state", "loading");
      try { start(CFG.spec); } catch (e) { fatal(String(e && e.message)); }
      return;
    }
    if (!CFG.specUrl) { fatal("The builder is missing its configuration."); return; }
    ROOT.setAttribute("data-state", "loading");
    fetch(CFG.specUrl, { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("spec HTTP " + r.status);
        return r.json();
      })
      .then(function (spec) {
        if (!spec || !spec.panels || !spec.steps) throw new Error("spec is not an apparel spec");
        start(spec);
      })["catch"](function (e) {
        fatal("The apparel builder could not load. " + (e && e.message ? e.message : ""));
      });
  }

  /* ------------------------------------------------------------ test API
     Same shape as the bat engine's window.CWEditor so the house harnesses can
     drive this one too: select() by panel title (exact) or by step label,
     payload() for the byte diff, state() for gating assertions. */
  window.CWApparel = {
    version: "cwa-v1",
    ready: function () { return !!SPEC; },
    spec: function () { return SPEC; },
    steps: function () {
      return steps().map(function (s, i) {
        var fx = FLOW.indexOf(i);
        return { i: i, flow: fx, fixed: fx < 0, label: s.label,
                 panel: (stepPanel(s) || {}).title || null, value: stepValue(s) };
      });
    },
    /* returns the label actually selected, or null when the option is not
       offered under the current build (a RETIRED historical label) */
    select: function (title, label) {
      var ps = panels(), i, j, p = null;
      for (i = 0; i < ps.length; i++) {
        if (ps[i].title === title && panelVisible(ps[i])) { p = ps[i]; break; }
      }
      if (!p) {
        var ss = steps();
        for (i = 0; i < ss.length; i++) {
          if (ss[i].label === title || ss[i].group === title) { p = stepPanel(ss[i]); break; }
        }
      }
      if (!p) return null;
      for (j = 0; j < p.options.length; j++) {
        if (p.options[j].label === label) return pick(p.id, p.options[j].id);
      }
      return null;
    },
    /* start from nothing (single-option panels re-auto-select). The order-diff
       harness calls this between rebuilds so each line is independent of the
       one before it -- a rebuild that only passes because a previous line left
       the right value behind is not a rebuild. */
    reset: resetBuild,
    go: function (i) { if (i <= maxOpen()) { STEP = i; render(); return true; } return false; },
    next: onNext, back: onBack,
    payload: buildPayload,
    props: function () {
      var o = {}, r = propRows(), i;
      for (i = 0; i < r.length; i++) o[r[i][0]] = r[i][1];
      return o;
    },
    state: function () {
      return { step: STEP, added: ADDED, busy: BUSY,
               missing: missingSteps().map(function (i) { return flowStep(i).label; }),
               visible: visiblePanels().map(function (p) { return p.title; }),
               keys: propRows().map(function (r) { return r[0]; }),
               combo: comboKey(), stage: stageUrl(comboKey() || comboKeyFallback()),
               qty: (function () { var o = {}, p = multiPanel(), ls = p ? qLines(p) : [], i;
                 for (i = 0; i < ls.length; i++) o[ls[i].label] = ls[i].n; return o; })(),
               total: qTotal() };
    },
    addToCart: addToCart,
    /* MULTI-SIZE: set a size's count directly (harness use) */
    qty: function (label, n) {
      var p = multiPanel(), i;
      if (!p) return null;
      for (i = 0; i < p.options.length; i++) {
        if (p.options[i].label === label) { qSet(p, p.options[i].id, n); render(); return QTY[p.options[i].id] || 0; }
      }
      return null;
    }
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
